import React, { useCallback, useEffect, useState } from 'react';

import { useLayoutContext } from '@ott/layout-context';

import FadeIn from 'src/components/elements/FadeIn';
import { TextNodes } from 'src/components/pages/PartnersPage/blocks/PartnersSlider/constants';

import { GATE_IO_IMAGES, KUCOIN_IMAGES, YONDER_IMAGES } from '../../constants';
import ArrowButton from './blocks/ArrowButton';
import Dots from './blocks/Dots';
import { useSliderButtons } from './hooks/useSliderButtons';

import { EmblaOptionsType } from 'embla-carousel';
import useEmblaCarousel from 'embla-carousel-react';

import styles from './PartnersSlider.scss';

const carouselOptions: EmblaOptionsType = {
  loop: true,
  slidesToScroll: 'auto',
};

const PartnersSlider = () => {
  const [selectedIndex, setSelectedIndex] = useState(1);
  const { isDesktop } = useLayoutContext();

  const [emblaRef, emblaApi] = useEmblaCarousel(carouselOptions);
  const { onPrevButtonClick, onNextButtonClick } = useSliderButtons(emblaApi);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, [emblaApi]);

  useEffect(() => {
    if (!emblaApi) return;

    emblaApi.on('select', onSelect);
    onSelect();

    return () => {
      emblaApi.off('select', onSelect);
    };
  }, [emblaApi, onSelect]);

  if (isDesktop) {
    return (
      <section className={styles.partnersSlider} data-locator="partnersSlider">
        <FadeIn delay={0.6}>
          <div className={styles.sliderContainer}>
            <div className={styles.arrowButtons}>
              <ArrowButton onClick={onPrevButtonClick} className={styles.arrowButtonPrev} />
              <ArrowButton onClick={onNextButtonClick} className={styles.arrowButtonNext} />
            </div>

            <div className={styles.slider} ref={emblaRef}>
              <div className={styles.slidesContainer}>
                <div className={styles.slide}>
                  <img
                    src={KUCOIN_IMAGES.srcDesktop}
                    alt={KUCOIN_IMAGES.alt}
                    className={styles.image}
                  />
                </div>
                <div className={styles.slide}>
                  <img
                    src={YONDER_IMAGES.srcDesktop}
                    alt={YONDER_IMAGES.alt}
                    className={styles.image}
                  />
                </div>
                <div className={styles.slide}>
                  <img
                    src={GATE_IO_IMAGES.srcDesktop}
                    alt={GATE_IO_IMAGES.alt}
                    className={styles.image}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className={styles.textNode}>
            {TextNodes[selectedIndex].textNode}
            {TextNodes[selectedIndex].linkNode}
          </div>
        </FadeIn>
      </section>
    );
  } else {
    return (
      <section className={styles.partnersSlider} data-locator="partnersSlider">
        <FadeIn delay={0.6}>
          <div className={styles.textNode}>{TextNodes[selectedIndex].textNode}</div>

          <div className={styles.sliderContainer}>
            <div className={styles.slider} ref={emblaRef}>
              <div className={styles.slidesContainer}>
                <div className={styles.slide}>
                  <img
                    src={KUCOIN_IMAGES.srcMobile}
                    alt={KUCOIN_IMAGES.alt}
                    className={styles.image}
                  />
                </div>
                <div className={styles.slide}>
                  <img
                    src={YONDER_IMAGES.srcMobile}
                    alt={YONDER_IMAGES.alt}
                    className={styles.image}
                  />
                </div>
                <div className={styles.slide}>
                  <img
                    src={GATE_IO_IMAGES.srcMobile}
                    alt={GATE_IO_IMAGES.alt}
                    className={styles.image}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className={styles.linkNode}>{TextNodes[selectedIndex].linkNode}</div>

          <Dots selectedIndex={selectedIndex} />
        </FadeIn>
      </section>
    );
  }
};

export default PartnersSlider;
